import React from 'react';
import useTooltip from '../../../../hooks/useTooltip';
import { IoSparklesOutline } from "react-icons/io5";
import './Insight.css';


const Insight = ({onClick, reasoning = false}) => {


  const {onMouseEnter, onMouseLeave, showTooltip} = useTooltip({  
    showDelay: 600, // milliseconds
    hideDelay: 600 // milliseconds
  });

  // aria-busy="true"
  return (
    <div className={`insightButton ${reasoning ? 'reasoning' : ''}`}>
      <div className='insightIcon' onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <IoSparklesOutline className='sparkle-icon' color='yellow' />
      </div>
      <div className='insightText'>
      </div>
      {showTooltip && (
        <div className='insightTooltip'>
          AI Insight
        </div>
      )}
    </div>
  );
};

export default React.memo(Insight);
